var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMergeTable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.7835C11.3807 10.7835 12.5 8.64189 12.5 6.00013C12.5 3.35837 11.3807 1.2168 10 1.2168C8.61929 1.2168 7.5 3.35837 7.5 6.00013C7.5 8.64189 8.61929 10.7835 10 10.7835Z",
    fill: "#1297DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25016 5.99935C6.25016 5.19102 6.44183 2.53268 8.77516 0.582682C8.12516 0.324349 7.41683 0.166016 6.66683 0.166016C3.45016 0.166016 0.833496 2.78268 0.833496 5.99935C0.833496 9.21602 3.45016 11.8327 6.66683 11.8327C7.41683 11.8327 8.12516 11.6743 8.77516 11.416C6.44183 9.46602 6.25016 6.80768 6.25016 5.99935Z",
    fill: "#1297DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 0.166016C12.5834 0.166016 11.8751 0.324349 11.2251 0.582682C13.5584 2.53268 13.7501 5.19102 13.7501 5.99935C13.7501 6.80768 13.5584 9.46602 11.2251 11.416C11.8751 11.6743 12.5834 11.8327 13.3334 11.8327C16.5501 11.8327 19.1668 9.21602 19.1668 5.99935C19.1668 2.78268 16.5501 0.166016 13.3334 0.166016Z",
    fill: "#1297DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeTable);
export default __webpack_public_path__ + "static/media/merge-table.1d6dd984eb162d1c91bb5b4a926146b8.svg";
export { ForwardRef as ReactComponent };